import { render, staticRenderFns } from "./photoCellItem.vue?vue&type=template&id=2c954b52&"
import script from "./photoCellItem.vue?vue&type=script&lang=js&"
export * from "./photoCellItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports